<template>
<div>
  <slot></slot>
  <v-row>
    <v-col v-if="admin">
      <v-icon @click="dialog=true" large color="red">mdi-image</v-icon>
    </v-col>

    <v-dialog v-model="dialog" max-width="900" persistent>
      <v-card>
        <v-card-text>
          <v-col cols="12">
            <h1>Gallerie</h1>
          </v-col>

          <v-col
            cols="12"
            style="max-height:500px; overflow:auto"
            v-for="(struttura,idstruttura) in strutture"
            :key="idstruttura"
          >
          {{struttura.descrizione}}
          <!--
            <v-card v-for="galleria in struttura.gallerie" :key="galleria.id">
              <v-card-title>{{struttura.descrizione}}</v-card-title>
              <v-card-subtitle>{{galleria.titolo}}</v-card-subtitle>
              <v-row>
                <v-col cols="3" v-for="n in galleria.immagini" :key="n.id">
                  <v-card>
                    <v-img :src="n.src" :lazy-src="n.lazy" aspect-ratio="1" class="grey lighten-2"></v-img>
                    <v-btn fab small bottom absolute right color="green" mb-1>
                      <v-icon @click="add(n)">mdi-plus</v-icon>
                    </v-btn>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          -->

          <v-tabs
              v-model="struttura.tab"
              background-color="deep-purple accent-4"
              class="elevation-2"
              dark
            >
              <v-tabs-slider></v-tabs-slider>
              
              <v-tab
                v-for="galleria in struttura.gallerie" :key="galleria.id"
                :href="`#tab-${galleria.id}`"
              >
              {{ galleria.titolo }}
                <v-icon v-if="icons">mdi-phone</v-icon>
              </v-tab>

              <v-tab-item
                v-for="galleria in struttura.gallerie" :key="galleria.id"
                :value="'tab-' + galleria.id"
              >
            <v-card >
              <v-row>
                <v-col cols="2" v-for="n in galleria.immagini" :key="n.id">
                  <v-card>
                    <v-img :src="n.src" :lazy-src="n.lazy" aspect-ratio="1" class="grey lighten-2"></v-img>
                    <v-btn fab small bottom absolute right color="green" mb-1>
                      <v-icon @click="add(n)">mdi-plus</v-icon>
                    </v-btn>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
              </v-tab-item>
            </v-tabs>
            </v-col>

          <v-spacer></v-spacer>
          <v-row style="max-height:500px; overflow:auto">
            <v-col>
            <v-card>
            <v-card-title>
              <h2>Immagini nel preventivo</h2>
            </v-card-title>
            <v-card-text>
              <v-row>
            <v-col cols="4" v-for="n in list" :key="n.id">
              <v-card>
                <v-img :src="n.src" aspect-ratio="1" class="grey lighten-2">
                  <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
                <v-btn fab small bottom absolute right color="red" mb-1>
                  <v-icon @click="del(n)" color="white">mdi-delete</v-icon>
                </v-btn>
              </v-card>
            </v-col>
            </v-row>
            </v-card-text>
            </v-card>
            </v-col>
          </v-row>
          <v-row></v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="updateValue()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </div>
</template>

<script>
//import firebase from "firebase";
export default {
  components: {},
  props: ["list", "admin"],
  model: {
    prop: "list",
    event: "listchange"
  },
  computed: {
    listLocal: {
      get: function() {
        return this.list;
      },
      set: function(value) {
        console.log("set lista", value);
        this.$emit("listchange", value);
      }
    },
    strutture(){
        return this.$store.state.strutture.data;
    },
    /*
    galleria: {
      get: function() {
        let rv = [];
        for (let index = 0; index < 10; index++) {
          rv.push({
            src: `https://picsum.photos/500/300?image=${index * 5 + 10}`,
            id: index,
            lazy: `https://picsum.photos/10/6?image=${index * 5 + 10}`
          });
        }
        return rv;
      },
      set: function() {}
    }
    */
  },
  data: () => ({
    dialog: false,
    icons:false,
  }),
  mounted() {
    /*
    this.$store
      .dispatch("strutture/fetchAndAdd", {
        where: [["idcliente", "==", firebase.auth().currentUser.uid]]
      })
      .then(data => {
        if (data) {
          this.strutture = this.$store.state.strutture.data;
          this.loading = false;
        }
      });
      */
  },
  methods: {
    updateValue: function() {
      this.dialog = false;
      this.$emit("input", this.value);
    },
    add(img) {
      var immaginiCopy = [...this.listLocal];
      immaginiCopy.push({ src: img.src });

      this.listLocal = immaginiCopy;
    },
    del(img) {
      var immaginiCopy = [...this.listLocal];
      var index = immaginiCopy.indexOf(img);
      immaginiCopy.splice(index, 1);

      this.listLocal = immaginiCopy;
    }
  }
};
</script>